// extracted by mini-css-extract-plugin
export default {"policy-details-skeleton":"styles_policy-details-skeleton__hFVTg","shimmer":"styles_shimmer__vUfhR"};